import { ResponsiveValues } from "@faire/web/slate/Theme/ResponsiveValues";

export const CATEGORY_KEY_PREFIX = "category:";

export const ALL_PRODUCTS_KEY = "All Products";

export const NEW_ARRIVALS_KEY = "New Arrivals";

export const STALE_TIME = 1000 * 60 * 5;

export const BRAND_PAGE_REDESIGN_MIN_PRODUCT_COUNT_FOR_CTA = 6;

export const BRAND_PAGE_REDESIGN_PRODUCTS_PER_ROW: ResponsiveValues<number> = {
  mobileAndAbove: 2,
  tabletAndAbove: 4,
  desktopAndAbove: 5,
  xLargeAndAbove: 6,
};

export const BRAND_PAGE_REDESIGN_MAX_ROW_COUNT_WITH_CTA: ResponsiveValues<number> =
  {
    mobileAndAbove: 5,
    tabletAndAbove: 3,
  };

export const BRAND_PAGE_REDESIGN_MAX_ROW_COUNT_WITHOUT_CTA: ResponsiveValues<number> =
  {
    mobileAndAbove: 4,
    tabletAndAbove: 2,
  };
